import { PaymentDetailsQueryResponse } from '../../home/paymentdetails/paymentdetailsqueryresponse';

export class PaymentReauthorize {
  FirstName: string;
  LastName: string;
  CCNumber: string;
  CCMonth: string;
  CCYear: string;
  CVV: string;
  ProfileId: string;
  AccountId: string;
  CCAddress: string;
  CCRegion: string;
  CCCountry: string;
  CCPostal: string;
  CCCity: string;
  ClientID: string;

  constructor(authInfo: PaymentDetailsQueryResponse) {
    this.FirstName = authInfo.FirstName;
    this.LastName = authInfo.LastName;
    this.CCNumber = authInfo.CardNumber;
    this.CCMonth = authInfo.Month;
    this.CCYear = authInfo.Year;
    this.CVV = authInfo.CVV;
    this.ProfileId = authInfo.ProfileId;
    this.AccountId = authInfo.AccountId;
    this.CCAddress = authInfo.CCAddress;
    this.CCRegion = authInfo.CCRegion;
    this.CCCountry = authInfo.CCCountry
    this.CCPostal = authInfo.CCPostal;
    this.CCCity = authInfo.CCCity;
    this.ClientID = authInfo.ClientID;
  }
}